























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Base64 } from 'js-base64';

import '@/globals';
import UnityBridge from '../unity-bridge';

@Component
export default class VideoPlayerPage extends Vue {

    @Prop(String) public videoUrlEncoded: string;

    get videoUrl() {
        return Base64.decode(this.videoUrlEncoded);
    }

    private player: HTMLVideoElement;

    public mounted() {
        this.player = this.$refs.player as HTMLVideoElement;
        this.player.addEventListener('play', this.onPlay);
        this.player.addEventListener('pause', this.onPause);
    }

    public beforeDestroy() {
        this.player.removeEventListener('play', this.onPlay);
        this.player.removeEventListener('pause', this.onPause);
    }

    public onAppearing() {
        new UnityBridge().send('unlockOrientation');
    }

    public onDisappearing() {
        new UnityBridge().send('lockOrientation');
    }

    public onPlay() {
        // We could request fullscreen here, but that makes navigation a bit akward
        // this.player.requestFullscreen();
    }

    public onPause() {
        // Would make sense if we start videos in fullscreen
        // this.player.webkitExitFullScreen();
    }
}
